import type { FlagsContext } from '@/contexts';

import type { FlagsContextInput } from '../types';

/**
 * Builds the complete LaunchDarkly evaluation context from the identity and
 * scope currently in hand.
 *
 * A scope kind is omitted rather than sent with an empty key when it is not
 * resolved yet: LaunchDarkly evaluates a context kind that is present, so a
 * placeholder would target nothing and quietly flip every flag keyed on that
 * kind to its fallback.
 */
const buildFlagsContext = ({
  user,
  selectedRegion,
  selectedRegionName,
  selectedCropSeason,
  selectedCropSeasonName
}: FlagsContextInput): FlagsContext => ({
  kind: 'multi',
  user: {
    key: user.id,
    email: user.email,
    name: user.name
  },
  ...(selectedRegion && {
    region: { key: selectedRegion, name: selectedRegionName }
  }),
  ...(selectedCropSeason && {
    cropSeason: { key: selectedCropSeason, name: selectedCropSeasonName }
  })
});

export default buildFlagsContext;
